export * from './lib/animal-selection-shell.module';
